import { Cobranded } from "@components/common/Cobranded";
import { PartnerProps, getPartnerStaticProps } from "@lib/partner";
import Partner from "@modules/application/pages/Partner";
import { NextPage } from "next";
import { useRouter } from "next/router";

const OnOfficePage: NextPage<PartnerProps> = ({ partner }) => {
  const { pathname } = useRouter();
  const pathSegments = pathname.split("/");
  const state =
    pathSegments[pathSegments.length - 1] === "pre" ? "pre" : "post";

  return (
    <Cobranded partner={partner}>
      <Partner state={state} clientMode="ONOFFICE" />
    </Cobranded>
  );
};

(OnOfficePage as any).applicationContextInitialValue = {
  applicationFormState: {
    values: [
      { applicationType: "BUY_WITH_SAVINGS" },
      { typeOfProperty: "APARTMENT" },
    ],
    history: [],
    currentStep: 2,
  },
};

export const getStaticPaths = () => {
  return { paths: [], fallback: "blocking" };
};
export const getStaticProps = getPartnerStaticProps;

export default OnOfficePage;
